import React, { useEffect, useState } from 'react';
import '../../App.css';
import './ShiftManagement.css';
import '../validate.css';
import axios from 'axios';
import { API_URL } from '../environment';
import withNavigation from '../withNavigation';

import { collectLoginClientInfo } from "../../helpers/browser-info";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 

// import iconOk from './../../images/ok-btn.svg';
// import iconClose from './../../images/icon-close.svg';
// import iconReplay from './../../images/icon-home.svg';
// import iconReceipt from './../../images/receipt.svg';
// import iconReprint from './../../images/reprint.svg';
// import iconRepeatBet from './../../images/icon-repeat-bet.svg';

import homeIcon from '../../images/icons/home-icon.svg';
import createIcon from '../../images/icons/create-icon.svg';
import validateIcon from '../../images/icons/validate-icon.svg';
import historyIcon from '../../images/icons/history-icon.svg';
import shiftIcon from '../../images/reprint.svg';


class ShiftManagement extends React.Component {



  state = {
    bettingShop: '',
    name: '',
    username: '',
    isEditing: false,
    shift20: 0,
    shift50: 0,
    shift100: 0,
    shift500: 0,
    shift1000: 0,
    shift2000: 0,
    shift5000: 0,
    shiftTotal: 0,
    shiftFi20: 0,
    shiftFi50: 0,
    shiftFi100: 0,
    shiftFi500: 0,
    shiftFi1000: 0,
    shiftFi2000: 0,
    shiftFi5000: 0,
    shiftFiTotal: 0,
    shiftCf20: 0,
    shiftCf50: 0,
    shiftCf100: 0,
    shiftCf500: 0,
    shiftCf1000: 0,
    shiftCf2000: 0,
    shiftCf5000: 0,
    shiftCfTotal: 0,
    expectedCloseTotal: 0,
    isShiftCreated: false,
    isShiftOpenDisabled: false,
    isFloatIncreaseDisabled: true,

    // start shift pop up
    isAuditorPending: false,
    isMenuOpen: false,
    topButtonsShow: true,
  }

  timeout;
  intervalId;
  forceDisplayAuditorPending;
  startShiftInProgress;

  constructor(props) {
    super(props);
    this.intervalId = null;
    this.forceDisplayAuditorPending=false;
    this.startShiftInProgressRef = React.createRef();
    this.startShiftInProgressRef.current = false;
  }


  navigateToPage = (page) => {
    this.props.navigate(page);    
  }

  toggleMenu = () => {
    const isOpen = this.state.isMenuOpen;
    this.setState({isMenuOpen: !isOpen});
  };

  onClearFields = () => {
    this.setState({
      bettingShop: '',
      name: '',
      username: '',
      isEditing: false,
      shift20: 0,
      shift50: 0,
      shift100: 0,
      shift500: 0,
      shift1000: 0,
      shift2000: 0,
      shift5000: 0,
      shiftTotal: 0,
      shiftFi20: 0,
      shiftFi50: 0,
      shiftFi100: 0,
      shiftFi500: 0,
      shiftFi1000: 0,
      shiftFi2000: 0,
      shiftFi5000: 0,
      shiftFiTotal: 0,
      shiftCf20: 0,
      shiftCf50: 0,
      shiftCf100: 0,
      shiftCf500: 0,
      shiftCf1000: 0,
      shiftCf2000: 0,
      shiftCf5000: 0,
      shiftCfTotal: 0,
      isShiftCreated: false,
      isShiftOpenDisabled: false,
      isFloatIncreaseDisabled: true,
      isShiftCloseDisabled: true,
    });
  };

  notify = (text = 'Text', type = 'success') => {
    toast[type](text, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 5000,
    });
  };

  showConfirmToast = (message) => {
    return new Promise((resolve) => {
      const toastId = toast(
        ({ closeToast }) => (
          <div className="w-[350px] text-center">
            <p className="text-lg font-medium mb-4">{message}</p>
            <div className="flex justify-center gap-6">
              <button
                onClick={() => {
                  toast.dismiss(toastId);
                  resolve(true);
                }}
                className="bg-green-600 hover:bg-green-700 text-black font-semibold py-2 px-4 rounded conf-btn"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  toast.dismiss(toastId);
                  resolve(false);
                }}
                className="bg-red-600 hover:bg-red-700 text-black font-semibold py-2 px-4 rounded conf-btn"
              >
                No
              </button>
            </div>
          </div>
        ),
        {
          closeOnClick: false,
          closeButton: false,
          autoClose: false,
          draggable: false,
          position: toast.POSITION.TOP_CENTER, // <== centered toast
        }
      );
    });
  };

  async calculateExpectedClose() {
    const userId = localStorage.getItem("sun_userId");
    const params = {
      agentId: userId,
      shiftActive: true,
    };

    const response = await axios.get(`${API_URL}/shifts`, {params}); // Example API URL
    const currentShift = (response?.data?.length && response.data[0]) || {};
    const curStats = currentShift?.stats || {};
    const expectedEndTotal = curStats.startTotal + curStats.floatIncreaseTotal + curStats.betTotal - curStats.redeemedTotal;
    return expectedEndTotal;
  }

  async loadCurrentShiftState() {
    if (this.forceDisplayAuditorPending) {
      return;
    }
    // load initial state 0f current shift
    const userId = localStorage.getItem("sun_userId");
    const params = {
      agentId: userId,
      shiftActive: true,
    };

    const response = await axios.get(`${API_URL}/shifts`, {params}); // Example API URL
    const currentShift = (response?.data?.length && response.data[0]) || {};
    const startDenom = currentShift.startDenom;
    const curStats = currentShift?.stats || {};
    const expectedEndTotal = curStats.startTotal + curStats.floatIncreaseTotal + curStats.betTotal - curStats.redeemedTotal;
    if (startDenom) {
      this.setState({
        isAuditorPending: currentShift.status === 'PENDING',
        shift20: startDenom[20] || 0,
        shift50: startDenom[50] || 0,
        shift100: startDenom[100] || 0,
        shift500: startDenom[500] || 0,
        shift1000: startDenom[1000] || 0,
        shift2000: startDenom[2000] || 0,
        shift5000: startDenom[5000] || 0,
      }, () => {
        // This callback runs AFTER state is updated    
        const totalVal = this.calculateTotal();
        let shiftTotalObj = { shiftTotal: totalVal };
  
        if (totalVal >= 0) {
          shiftTotalObj = {
            ...shiftTotalObj,
            isShiftCreated: true,
            isShiftOpenDisabled: true,
            isFloatIncreaseDisabled: false,
            isShiftCloseDisabled: true,
            expectedCloseTotal: expectedEndTotal,
          };
        }
        this.setState(shiftTotalObj);
      });
    } else {
      this.onClearFields();
      this.setState({isAuditorPending: false});
    }
  }

  async componentDidMount() {

    const storedUserRaw = localStorage.getItem("sun_user");
    let storedUser;

    try {
      storedUser = JSON.parse(storedUserRaw);
    } catch (e) {
      storedUser = {};
    }

    const agentID = localStorage.getItem("sun_userId") || '';
    const bettingShopID = localStorage.getItem('sun_bettingShopId') || '';
    let stateObj = {};
    // load betting shop name
    if (agentID && bettingShopID) {
      try {
          const checkShiftRes = await axios.post(`${API_URL}/checkactiveshift`, {
            bettingShopId: bettingShopID,
            agentId: agentID,
          });

          const hasActiveShift = checkShiftRes?.data?.hasActiveShift;
          const isPendingShift = checkShiftRes?.data?.shiftStatus === 'PENDING';
          if (storedUser?.role === 'CASHIER' && (!hasActiveShift || isPendingShift)) {
            stateObj.topButtonsShow = false;
          }
          // if (storedUser?.role === 'CASHIER') {
          //     setIsMenuOpen(true);
          // }
        } catch (err) {
          console.error('Failed to check active shift:', err);
        }    
    }


    // const fetchShiftData = async () => {

    // };
  
    // fetchShiftData();





    document.body.classList.add('validate-active');
    await this.loadCurrentShiftState();

    // const storedUser = JSON.parse(localStorage.getItem("sun_user"));
    const isCashier = storedUser && storedUser.role === 'CASHIER';
    if (isCashier) {
      this.setState({
        ...stateObj,
        isMenuOpen: true,
      });
    }

    this.intervalId = setInterval(async() => {
      if (this.state.isAuditorPending === true) {
        await this.loadCurrentShiftState();
      }
    }, 15000);
  }

  componentWillUnmount() { 
    clearTimeout(this.timeout);
    clearTimeout(this.intervalId);
  }

  calculateTotal = (type = '') => {
    const totalVal = this.state[`shift${type}20`] * 20 + this.state[`shift${type}50`] * 50 + this.state[`shift${type}100`] * 100
         + this.state[`shift${type}500`] * 500 + this.state[`shift${type}1000`] * 1000 + this.state[`shift${type}2000`] * 2000 + this.state[`shift${type}5000`] * 5000;
    return totalVal;
  }

  // Handle changes to the inputs
  handleDenomChange = (event) => {
    const { name, value } = event.target;
    // Extract denomination value from the name (e.g., shift20 → 20)
    const denomMatch = name.match(/\d+/); // regex to extract numbers
    const denom = denomMatch ? parseInt(denomMatch[0], 10) : null;

    let parsedVal = value;
    if (!value || value.indexOf('shift') !== -1) {
      parsedVal = 0;
      console.log('cond, ', !value || value.indexOf('shift') !== -1)
    }
    parsedVal = parseInt(parsedVal, 10);
    console.log('denom', denom, parsedVal);

    // this.setState({ [name]: value,  }); // Update the corresponding state

    let pref = '';
    if (name?.indexOf('Fi') !== -1) {
      pref = 'Fi';
    } else if (name?.indexOf('Cf') !== -1) {
      pref = 'Cf';
    }

    this.setState({ [name]: value }, () => {
      // This callback runs AFTER state is updated    
      const totalVal = this.calculateTotal(pref);
      this.setState({ [`shift${pref}Total`]: totalVal });
    });
  };

  // Pass the state values to the onStartShift function
  handleStartShift = () => {
    const { name, username } = this.state;
    // if (!(name && username && password && role && bettingShop)) {
    //   alert('Please fill all fields');
    //   return;
    // }
    this.onStartShift(name, username ); // Call the function with input values
  };


  onStartShift = async (name, username) => {
    if (this.startShiftInProgressRef.current) {
      console.log('Shift start already in progress');
      this.notify('Shift start already in progress', 'warning');
      return;
    }

    this.startShiftInProgressRef.current = true;

    try {
      // if (this.state.shiftTotal === 0) {
      //   alert('Please enter at least one value');
      //   return;
      // }

      const storedUserId = localStorage.getItem("sun_userId") || '';
      const bettingShopId = localStorage.getItem('sun_bettingShopId') || '';

      // const bettingShopFiltered = bettingShop; // role === 'ADMIN' ? '' : bettingShop; 
      console.log("bettingShopId", bettingShopId);

      const startDenom = {
        20: parseInt(this.state.shift20, 10),
        50: parseInt(this.state.shift50, 10),
        100: parseInt(this.state.shift100, 10),
        500: parseInt(this.state.shift500, 10),
        1000: parseInt(this.state.shift1000, 10),
        2000: parseInt(this.state.shift2000, 10),
        5000: parseInt(this.state.shift5000, 10),
      };
      
      const endDenom = {
        20: 0,
        50: 0,
        100: 0,
        500: 0,
        1000: 0,
        2000: 0,
        5000: 0,
      };

      const shiftTotal = this.state.shiftTotal;

      const response = await axios.post(`${API_URL}/startshift`, {bettingShopId, startDenom, endDenom, shiftTotal, agentId: storedUserId, status: 'OPEN'});
      // console.log('create response', response);
      const userId = localStorage.getItem("sun_userId");

      // GET ip address
      const IP_SERVICE = 'https://api64.ipify.org/?format=json';
      const ipRes = await axios.get(IP_SERVICE);
      // console.log('ipRes', ipRes);
      const curIp = (ipRes && ipRes.data && ipRes.data.ip) || 0;

      const metadata = await collectLoginClientInfo({
        includeGeolocation: true,
        geolocationOptions: {
          enableHighAccuracy: false,
          timeout: 2000,
          maximumAge: 300000,
        },
      });

      const role = localStorage.getItem("sun_userRole");
      
      try {
        await axios.post(`${API_URL}/logaction`, {
          action: 'start_shift',
          user: userId,
          role,
          bettingShopId: bettingShopId,
          ipAddress: curIp,
          metadata,
          denom: startDenom,
        });
      } catch (e) {
        console.log(e);
      }

      const expectedClose = await this.calculateExpectedClose();

      this.setState({
        isShiftCreated: true,
        isShiftOpenDisabled: true,
        isFloatIncreaseDisabled: false,
        isShiftCloseDisabled: true,  
        expectedCloseTotal: expectedClose,
      });
      this.notify('Shift Started', 'success');
    } catch (error) {
      console.error('Error starting shift:', error);
      this.notify('Error starting shift', 'error');
    } finally {
      setTimeout(() => {
        this.startShiftInProgressRef.current = false;
      }, 5000);
    }
  };

  handleFloatChange = async() => {
    if (this.state.shiftFiTotal === 0) {
      this.notify('Please enter at least one value', 'success');
      return;
    }

    // update current object, read array etc.
    const addFloatDenom = {
      20: parseInt(this.state.shiftFi20, 10),
      50: parseInt(this.state.shiftFi50, 10),
      100: parseInt(this.state.shiftFi100, 10),
      500: parseInt(this.state.shiftFi500, 10),
      1000: parseInt(this.state.shiftFi1000, 10),
      2000: parseInt(this.state.shiftFi2000, 10),
      5000: parseInt(this.state.shiftFi5000, 10),
    };

    const totalVal = this.calculateTotal('Fi');
    const userId = localStorage.getItem("sun_userId");

    const addFloatObj = {
      $push: {
        floatIncreases: {
          denom: addFloatDenom,
          total: totalVal,
          createdAt: new Date().toISOString(),
        }
      },
      agentId: userId,
      currentFloatIncreaseSum: this.state.shiftFiTotal,
    };

  
    try {
      const response = await axios.post(`${API_URL}/shiftaddfloat`, addFloatObj);

      const expectedClose = await this.calculateExpectedClose();

      this.setState({
        isShiftCreated: true,
        isShiftOpenDisabled: true,
        isFloatIncreaseDisabled: false,
        isShiftCloseDisabled: true,
        shiftFi20: 0,
        shiftFi50: 0,
        shiftFi100: 0,
        shiftFi500: 0,
        shiftFi1000: 0,
        shiftFi2000: 0,
        shiftFi5000: 0,
        shiftFiTotal: 0,
        expectedCloseTotal: expectedClose,
      });
      this.notify('Float Increase Submitted', 'success');

      const bettingShopID = localStorage.getItem('sun_bettingShopId') || '';

      // GET ip address
      const IP_SERVICE = 'https://api64.ipify.org/?format=json';
      const ipRes = await axios.get(IP_SERVICE);
      // console.log('ipRes', ipRes);
      const curIp = (ipRes && ipRes.data && ipRes.data.ip) || 0;

      const metadata = await collectLoginClientInfo({
        includeGeolocation: true,
        geolocationOptions: {
          enableHighAccuracy: false,
          timeout: 2000,
          maximumAge: 300000,
        },
      });

      const role = localStorage.getItem("sun_userRole");

      try {
        await axios.post(`${API_URL}/logaction`, {
          action: 'float_increase',
          user: userId,
          role,
          bettingShopId: bettingShopID,
          ipAddress: curIp,
          metadata,
          denom: addFloatDenom,
        });
      } catch (e) {
        console.log(e);
      }      

    } catch (err) {
      console.log(err);
      // setError(err.message); // Update state with error message
      // setLoading(false); // Set loading to false
    }
  };

  // sendEmailNotification = async() => {
  //   const storedUserId = localStorage.getItem("sun_userId") || '';
  //   const responseEmail = await axios.post(`${API_URL}/sendemail`, {agentId: "672acfe0e969b786a49ff18c", shiftId: "6811ad7dc6b63fb6594fda5e"});
  //   console.log('responseEmail', responseEmail);
  // };
  // onClick={() => { this.sendEmailNotification() }}


  onCloseShift = async() => {
    const closeShiftTotal = this.state.shiftCfTotal;
    const storedUserId = localStorage.getItem("sun_userId") || '';
  
    const endDenom = {
      20: parseInt(this.state.shiftCf20, 10),
      50: parseInt(this.state.shiftCf50, 10),
      100: parseInt(this.state.shiftCf100, 10),
      500: parseInt(this.state.shiftCf500, 10),
      1000: parseInt(this.state.shiftCf1000, 10),
      2000: parseInt(this.state.shiftCf2000, 10),
      5000: parseInt(this.state.shiftCf5000, 10),
    };

    // verify shift balance before close
    // it should be expectedEndTotal === this.state.shiftCfTotal
    // expectedEndTotal = startTotal + floatIncreaseTotal + betTotal - redeemedTotal

    const params = {
      agentId: storedUserId,
      shiftActive: true,
    };

    const shiftsRes = await axios.get(`${API_URL}/shifts`, {params});
    const currentShift = (shiftsRes?.data?.length && shiftsRes.data[0]) || {};
    const curStats = currentShift?.stats || {};
    const expectedEndTotal = curStats.startTotal + curStats.floatIncreaseTotal + curStats.betTotal - curStats.redeemedTotal;

    let shiftBalance = true;
    // if (this.state.shiftCfTotal !== expectedEndTotal) {
    //   shiftBalance = false;
    //   if ( window.confirm('Your closing shift does NOT balance, would you still like to end shift?') === false ) {
    //     return;
    //   } else {
    //     // sent email notification
    //     try {
    //       await axios.post(`${API_URL}/sendemail`, {agentId: storedUserId, shiftId: currentShift._id});
    //     } catch (err) {
    //       console.log(err);
    //     }
    //   }
    // }

    if (this.state.shiftCfTotal !== expectedEndTotal) {
      shiftBalance = false;
    }

    const confirm = await this.showConfirmToast(
      'Are you confirming all values entered are correct and true?'
    );
  
    if (!confirm) {
      return;
    }

    const closeResp = await axios.post(`${API_URL}/closeshift`, {shiftId: currentShift._id, endDenom, cashierDenom: endDenom, closeShiftTotal, agentId: storedUserId, shiftBalance});
    // User confirmed → send email
    // Try to send email, but don't stop if it fails
    // const timezoneOffsetHours = -new Date().getTimezoneOffset() / 60; // Convert to hours
    const formatLocalDate = (iso) => {
      if (!iso) return 'Invalid Date';
    
      // Ensure ISO format is valid (insert colon in timezone offset)
      const fixedIso = iso.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
    
      return new Date(fixedIso).toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    };

    // ************************* time format for email exampl ******************************
    // const shiftData = closeResp?.data || {};
    // const formattedStart = formatLocalDate(shiftData?.data?.startedShiftAt);
    // const formattedEnd = formatLocalDate(shiftData?.data?.endedShiftAt);

    // axios.post(`${API_URL}/sendemail`, {
    //   agentId: storedUserId,
    //   shiftId: currentShift._id,
    //   formattedStart,
    //   formattedEnd,
    // }).catch(err => {
    //   console.error("Failed to send shift imbalance email:", err);
    // });
    // ************************ end email example time format *******************************

    const userId = localStorage.getItem("sun_userId");
    const bettingShopID = localStorage.getItem('sun_bettingShopId') || '';

    // GET ip address
    const IP_SERVICE = 'https://api64.ipify.org/?format=json';
    const ipRes = await axios.get(IP_SERVICE);
    // console.log('ipRes', ipRes);
    const curIp = (ipRes && ipRes.data && ipRes.data.ip) || 0;

    const metadata = await collectLoginClientInfo({
      includeGeolocation: true,
      geolocationOptions: {
        enableHighAccuracy: false,
        timeout: 2000,
        maximumAge: 300000,
      },
    });

    const role = localStorage.getItem("sun_userRole");
    
    try {
      await axios.post(`${API_URL}/logaction`, {
        action: 'close_shift',
        user: userId,
        role,
        shiftId: currentShift._id,
        bettingShopId: bettingShopID,
        ipAddress: curIp,
        metadata,
        denom: endDenom,
      });
    } catch (e) {
      console.log(e);
    }


    let newStateObj = {
      isShiftCreated: true,
      isShiftOpenDisabled: true,
      isFloatIncreaseDisabled: false,
      isShiftCloseDisabled: true,
      isAuditorPending: true,
    };


    this.setState(newStateObj);
    const notifyText = 'Shift in review. Please wait...';
    this.notify(notifyText, 'success');
    this.onClearFields();

    this.forceDisplayAuditorPending = true;
    this.timeout = setTimeout(() => {
      if (shiftBalance) {
        this.setState({ isAuditorPending: false });
        this.notify('Shift Closed', 'success');
      } else {
        this.notify('Submitted to Auditor for Review', 'success');
      }

      // 3️⃣ allow polling again
      this.forceDisplayAuditorPending = false;
      clearTimeout(this.timeout);
    }, 15000);
    window.location.href = '/shift-management';
    // window.location.reload();
  };

  render() {    
      return <> 
      {this.state.isAuditorPending && (
        <div className="shift-pop-up">
          <h1>Your shift has been changed to PENDING status, please wait while it is reviewed...</h1>
        </div>
      )}
      <ToastContainer
        position="top-center"
        hideProgressBar
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
      />

      <div className="dashbord-wr"> 
      
          {/* Role Selection Buttons Debug */}

          <div className={`admin-page-menu ${this.state.isMenuOpen ? 'menu-open' : 'menu-closed'}`}>
        {/* Toggle button */}
        {/* <div className="admin-page-menu__toggle" onClick={this.toggleMenu}>
          <div className="admin-page-menu__toggle-icon">
            <img src={this.state.isMenuOpen ? iconClose : iconOk} alt={this.state.isMenuOpen ? "Close" : "Open"} />
          </div>
        </div> */}
        
        {/* Menu items - only show when menu is open */}
        {this.state.isMenuOpen && (
          <>
            <div className="admin-page-menu__item" onClick={() => this.navigateToPage('/dashboard')}>
              <div className="admin-page-menu__item-icon">
                <img src={homeIcon} alt="Home" />
              </div>
              <div className="admin-page-menu__item-title">
                <span>Home</span>
              </div>
            </div>
            <div className={`admin-page-menu__item ${this.state.topButtonsShow?'':'gray-out'}`} onClick={() => this.navigateToPage('/admin')}>
              <div className="admin-page-menu__item-icon">
                <img src={createIcon} alt="Create" />
              </div>
              <div className="admin-page-menu__item-title">
                <span>Create</span>
              </div>
            </div>
            <div className={`admin-page-menu__item ${this.state.topButtonsShow?'':'gray-out'}`} onClick={() => this.navigateToPage('/validate')}>
              <div className="admin-page-menu__item-icon">
                <img src={validateIcon} alt="Validate" />
              </div>
              <div className="admin-page-menu__item-title">
                <span>Validate</span>
              </div>
            </div>
            <div className={`admin-page-menu__item ${this.state.topButtonsShow?'':'gray-out'}`} onClick={() => this.navigateToPage('/tickethistory')}>
              <div className="admin-page-menu__item-icon">
                <img src={historyIcon} alt="History" />
              </div>
              <div className="admin-page-menu__item-title">
                <span>History</span>
              </div>
            </div>
            <div className="admin-page-menu__item" onClick={() => this.navigateToPage('/shift-management')}>
              <div className="admin-page-menu__item-icon">
                <img src={shiftIcon} alt="Shift" />
              </div>
              <div className="admin-page-menu__item-title">
                <span>Shift</span>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="validate">
        <div className="validate-left-shift">
          <div className="spin-border dashbord-border shift-management-title">
            <div className="spin-light spin-light-top">
              <div className="spin-light-container">
                {Array.from({ length: 15 }).map((_, index) => (
                  <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                ))}
              </div>
            </div>
            <div className="spin-number">
              <div className="spin-number__text">
                <span className="spin-number__text-big">SHIFT MANAGEMENT</span> 
              </div> 
            </div>
            <div className="spin-light spin-light-bottom">
              <div className="spin-light-container">
                {Array.from({ length: 15 }).map((_, index) => (
                  <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                ))}
              </div>
            </div>
          </div>

          <div className="bet-wrap-full">

          <div className={`betting-form left-shifts-wrap ${this.state.isShiftCreated ? 'gray-out' : ''}`}>
            <div className="open-shift-btn-wrap">
            <button className={`btn-mrg-bottom ${this.state.isShiftOpenDisabled ? 'btn-blue' : 'btn-green'}`}>
                Open Shift
            </button>
            </div>
            {/* Hidden dummy input to trick autofill */}
            <input type="text" style={{ display: "none" }} autoComplete="shift20" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>20 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift20"
                autoComplete="off"
                value={this.state.shift20}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift20 * 20}</label>
            </div>
    
            <input type="password" style={{ display: "none" }} autoComplete="shift50" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>50 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift50"
                autoComplete="off"
                value={this.state.shift50}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift50 * 50}</label>
            </div>

            {/* Hidden dummy password input */}
            <input type="password" style={{ display: "none" }} autoComplete="shift100" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>100 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift100"
                autoComplete="off"
                value={this.state.shift100}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift100 * 100}</label>
            </div>


            <input type="text" style={{ display: "none" }} autoComplete="shift500" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>500 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift500"
                autoComplete="off"
                value={this.state.shift500}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift500 * 500}</label>
            </div>

            <input type="text" style={{ display: "none" }} autoComplete="shift1000" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>1000 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift1000"
                autoComplete="off"
                value={this.state.shift1000}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift1000 * 1000}</label>
            </div>


            <input type="text" style={{ display: "none" }} autoComplete="shift2000" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>2000 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift2000"
                autoComplete="off"
                value={this.state.shift2000}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift2000 * 2000}</label>
            </div>

            <input type="text" style={{ display: "none" }} autoComplete="shift5000" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>5000 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shift5000"
                autoComplete="off"
                value={this.state.shift5000}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shift5000 * 5000}</label>
            </div>

            <div className="betting-form__row total-wrap">
              <label className='bet-row-lbl bet-row-left'>Total</label>
              <label className="bet-row-lbl"> = {this.state.shiftTotal || 0}</label>
            </div>

            {/* <div className="betting-form__row total-wrap hidden-total">
              <label className='bet-row-lbl bet-row-expect-close'>Expected Close</label>
              <label className="bet-row-lbl"> = </label>
            </div> */}

            <div className="btn-bottom-subm">
              <button className="btn-orange btn-mrg-bottom" onClick={() => this.handleStartShift()}>
                Submit Opening Float
              </button>
            </div>

          </div>



          <div className={`betting-form left-shifts-wrap ${!this.state.isShiftCreated ? 'gray-out' : ''}`}>
            <div className="open-shift-btn-wrap">
            <button className={`btn-mrg-bottom ${this.state.isFloatIncreaseDisabled ? 'btn-blue' : 'btn-green'} ${this.state.isShiftCreated ? 'gray-out' : ''}`} 
              onClick={() => { 
                this.setState({
                  isFloatIncreaseDisabled: false,
                  isShiftCloseDisabled: true,
                });
              }}>
              Float Increase
            </button>
            </div>
            <div className={`column ${this.state.isFloatIncreaseDisabled ? 'gray-out' : ''}`}>
            <input type="text" style={{ display: "none" }} autoComplete="shiftFi20" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>20 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftFi20"
                autoComplete="off"
                value={this.state.shiftFi20}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftFi20 * 20}</label>
            </div>
    
            <input type="text" style={{ display: "none" }} autoComplete="shiftFi50" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>50 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftFi50"
                autoComplete="off"
                value={this.state.shiftFi50}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftFi50 * 50}</label>
            </div>

            <input type="password" style={{ display: "none" }} autoComplete="shiftFi100" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>100 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftFi100"
                autoComplete="off"
                value={this.state.shiftFi100}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftFi100 * 100}</label>
            </div>

            <input type="text" style={{ display: "none" }} autoComplete="shiftFi500" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>500 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftFi500"
                autoComplete="off"
                value={this.state.shiftFi500}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftFi500 * 500}</label>
            </div>

            <input type="text" style={{ display: "none" }} autoComplete="shiftFi1000" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>1000 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftFi1000"
                autoComplete="off"
                value={this.state.shiftFi1000}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftFi1000 * 1000}</label>
            </div>


            <input type="text" style={{ display: "none" }} autoComplete="shiftFi2000" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>2000 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftFi2000"
                autoComplete="off"
                value={this.state.shiftFi2000}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftFi2000 * 2000}</label>
            </div>

            <input type="text" style={{ display: "none" }} autoComplete="shiftFi5000" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>5000 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftFi5000"
                autoComplete="off"
                value={this.state.shiftFi5000}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftFi5000 * 5000}</label>
            </div>

            <div className="betting-form__row total-wrap">
              <label className='bet-row-lbl bet-row-left'>Total</label>
              <label className="bet-row-lbl"> = {this.state.shiftFiTotal}</label>
            </div>

            {/* <div className="betting-form__row total-wrap hidden-total">
              <label className='bet-row-lbl bet-row-expect-close'>Expected Close</label>
              <label className="bet-row-lbl"> = </label>
            </div> */}

            <div className="btn-bottom-subm">
            {/* <button className="betting-form__btn btn-orange btn-mrg-bottom" onClick={() => this.handleFloatChange()}> */}
            <button className="btn-orange btn-mrg-bottom" onClick={() => this.handleFloatChange()}>
                Submit Float Change
              </button>
            </div>

          </div>
          </div>




          <div className={`betting-form left-shifts-wrap ${!this.state.isShiftCreated ? 'gray-out' : ''}`}>
            <div className="open-shift-btn-wrap">
            <button className={`btn-mrg-bottom ${this.state.isShiftCloseDisabled ? 'btn-blue' : 'btn-green'} ${this.state.isShiftCreated ? 'gray-out' : ''}`} 
              onClick={() => { 
                this.setState({
                  isShiftCloseDisabled: false,
                  isFloatIncreaseDisabled: true,
                });
              }}>
              Close Shift
            </button>
            </div>
            <div className={`column ${this.state.isShiftCloseDisabled ? 'gray-out' : ''}`}>
            <input type="text" style={{ display: "none" }} autoComplete="shiftCf20" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>20 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftCf20"
                autoComplete="off"
                value={this.state.shiftCf20}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftCf20 * 20}</label>
            </div>

            <input type="text" style={{ display: "none" }} autoComplete="shiftCf50" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>50 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftCf50"
                autoComplete="off"
                value={this.state.shiftCf50}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftCf50 * 50}</label>
            </div>

            <input type="password" style={{ display: "none" }} autoComplete="shiftCf100" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>100 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftCf100"
                autoComplete="off"
                value={this.state.shiftCf100}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftCf100 * 100}</label>
            </div>


            <input type="text" style={{ display: "none" }} autoComplete="shiftCf500" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>500 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftCf500"
                autoComplete="off"
                value={this.state.shiftCf500}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftCf500 * 500}</label>
            </div>

            <input type="text" style={{ display: "none" }} autoComplete="shiftCf1000" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>1000 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftCf1000"
                autoComplete="off"
                value={this.state.shiftCf1000}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftCf1000 * 1000}</label>
            </div>


            <input type="text" style={{ display: "none" }} autoComplete="shiftCf2000" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>2000 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftCf2000"
                autoComplete="off"
                value={this.state.shiftCf2000}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftCf2000 * 2000}</label>
            </div>

            <input type="text" style={{ display: "none" }} autoComplete="shiftCf5000" />
            <div className="betting-form__row">
              <label className='bet-row-lbl bet-row-left'>5000 x</label>
              <input
                className="betting-form__input bet-row-input"
                type="number"
                min="0"
                placeholder="0"
                name="shiftCf5000"
                autoComplete="off"
                value={this.state.shiftCf5000}
                onChange={this.handleDenomChange}
              />
              <label className="bet-row-lbl">QTY = {this.state.shiftCf5000 * 5000}</label>
            </div>

            <div className="betting-form__row total-wrap">
              <label className='bet-row-lbl bet-row-left'>Total</label>
              <label className="bet-row-lbl"> = {this.state.shiftCfTotal}</label>
            </div>

            {/* <div className="betting-form__row total-wrap">
              <label className='bet-row-lbl bet-row-expect-close'>Expected Close</label>
              <label className="bet-row-lbl"> = {this.state.expectedCloseTotal}</label>
            </div> */}

            {/* <div className="betting-form__row total-wrap hidden-total">
              <label className='bet-row-lbl bet-row-expect-close'>Expected Close</label>
              <label className="bet-row-lbl"> = </label>
            </div> */}

            <div className="btn-bottom-subm">
              <button className="btn-orange btn-mrg-bottom" onClick={() => this.onCloseShift()}>
                Submit Closing Float
              </button>
            </div>

          </div>
          </div>


          <button className="return-menu-btn btn-yellow-shift"
              onClick={() => this.navigateToPage('/dashboard')}>RETURN TO MAIN MENU</button>

          {/* <div className="validate-right">

          </div> */}


          </div>

        </div>
      </div>
      </div>
      </>;
  }
}

export default withNavigation(ShiftManagement);
